import { drama } from '../../constants/actionTypes';

export default (state = {}, { type, payload }) => {
  switch (type) {
    case drama.FETCH_DRAMA_CATEGORY_SUCCESS:
      return payload?.normalizedData ? payload.normalizedData.entities.categories : state;

    default:
      return state;
  }
};
